// extracted by mini-css-extract-plugin
module.exports = {"contactInfoValue":"src-lib-app-components-elements-textDisplays-ContactInfoValue-index-module__contactInfoValue--1-12v"};